export default () => {
  const cards = document.querySelectorAll('[component="card"]');

  cards.forEach((card) => {
    const bodyChild = card.querySelector('[child="body"]');
    const buttonChild = card.querySelector('[child="button"]');

    if (bodyChild) {
      const { borderColor, backgroundColor, textColor } = bodyChild.dataset;

      if (borderColor) {
        bodyChild.style.borderColor = borderColor;
      }

      if (backgroundColor) {
        bodyChild.style.backgroundColor = backgroundColor;
      }

      if (textColor) {
        bodyChild.style.color = textColor;
      }
    }

    if (buttonChild) {
      const { bgColor, textColor } = buttonChild.dataset;

      if (bgColor) {
        buttonChild.style.backgroundColor = bgColor;
      }

      if (textColor) {
        buttonChild.style.color = textColor;
      }
    }
  });
};
